import React from 'react';

const ProdutoFilterBar = ({ filters, onChange }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 mb-4 w-full max-w-full">
      <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 gap-2 w-full">
        <input
          type="text"
          name="nome"
          placeholder="Nome do Produto"
          value={filters.nome}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="status"
          placeholder="Status"
          value={filters.status}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="tipoProduto"
          placeholder="Tipo Produto"
          value={filters.tipoProduto}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
      </div>
    </div>
  );
};

export default ProdutoFilterBar;
